
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class extends Vue {
  splittedText: string[] = [];

  @Prop()
  text!: string;

  mounted() {
    this.splittedText = this.text.split("");
  }
}
